/**
 * Centralized catalog of visual assets and image paths.
 * Guarantees type safety and consistent URLs across the application.
 */

export const IMAGES = {
  logo: "/logo.png",
  logoAssets: "/assets/images/logo.png",
  logoSvg: "/assets/images/logo.svg",
  professorVagner: "/professor-vagner-lima.jpeg",
  professorVagnerAssets: "/assets/images/professor-vagner-lima.jpeg",
  corporativo: "/executive-jiu-jitsu-corporativo.jpeg",
  corporativoAssets: "/assets/images/executive-jiu-jitsu-corporativo.jpeg",
  logoVagnao: "/logo-vagnao-lima.jpeg",
  logoVagnaoAssets: "/assets/images/logo-vagnao-lima.jpeg",
  favicon: "/logo.png",
} as const;

export default IMAGES;
